import errorCodes from "@/apis/error";
import { categoryDel } from "@/apis/product";
import { notification } from "antd";
import i18next from "i18next";
import { useState } from "react";


type Del = (delId: string) => Promise<void>
type IUseCategoryDel = () => [ boolean, { del: Del } ]

const IUseCategoryDel: IUseCategoryDel = () => {
  const [delLoading, setDelLoading] = useState<boolean>(true);

  const del: Del = (id) => {
    setDelLoading(true)
    return new Promise((resolve) => {
      categoryDel(id)
        .then(() => {
          setDelLoading(false)
          resolve()
          notification.success({ placement: 'top', message: i18next.t('common.rmSuccess') });
        })
        .catch((err) => notification.error({ placement: 'top', message: errorCodes[err] || err }))
        .finally(() =>  setDelLoading(false))
    })
  }

  return [ delLoading, { del }];
};

export default IUseCategoryDel;